import { isMobile } from '../../utils/device-utils';

const NAV_SELECTOR = '.j-nav-custom';
const ITEMS_SELECTOR = '.c-nav-custom__item';
const OPEN_ITEM_CLASS = 'isOpen';
const DESKTOP_NAV_CLASS = 'c-nav-custom--desktop';

const removeOpenItems = (item) => item.classList.remove(OPEN_ITEM_CLASS);

export const init = ($navCustomMenu) => {
  if (isMobile()) {
    const items = $navCustomMenu.querySelectorAll(ITEMS_SELECTOR);
    items.forEach((li) =>
      li.addEventListener('click', () => {
        // Remove the activeClassName from other items
        [...items].filter((item) => item !== li).forEach(removeOpenItems);

        // Toggle activeClassName to current item
        li.classList.toggle(OPEN_ITEM_CLASS);
      })
    );
    document.addEventListener('click', (e) => {
      if (!$navCustomMenu.contains(e.target)) {
        items.forEach(removeOpenItems);
      }
    });
  } else {
    $navCustomMenu.classList.add(DESKTOP_NAV_CLASS);
  }
};
